
export enum ProjectileConfigId {
    NONE,
    // the rest are set by index into array dynamically
}
